const CoinsSvg = ({ fill }) => (
	<div>
		<svg style={{marginTop : "4px"}} width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M25.1875 0C26.7886 0 28.1577 0.586806 29.2946 1.76042C30.4315 2.93403 31 4.34722 31 6V26C31 27.6528 30.4315 29.066 29.2946 30.2396C28.1577 31.4132 26.7886 32 25.1875 32H21.3932V19.6042H25.4095L26.015 14.7708H21.3932V11.6875C21.3932 10.9097 21.5513 10.3264 21.8675 9.9375C22.1837 9.54861 22.7993 9.35417 23.7142 9.35417L26.1764 9.33333V5.02083C25.3288 4.89583 24.1313 4.83333 22.584 4.83333C20.7541 4.83333 19.2909 5.38889 18.1943 6.5C17.0978 7.61111 16.5495 9.18056 16.5495 11.2083V14.7708H12.513V19.6042H16.5495V32H5.8125C4.21137 32 2.84234 31.4132 1.7054 30.2396C0.568468 29.066 0 27.6528 0 26V6C0 4.34722 0.568468 2.93403 1.7054 1.76042C2.84234 0.586806 4.21137 0 5.8125 0H25.1875Z"
				fill={fill}
			/>
		</svg>
	</div>
);
export default CoinsSvg;
